import DefaultValuesUtils from "./DefaultValuesUtils";

class StringUtils {
  static sanitizeText(text, field) {
    return text.replace(DefaultValuesUtils.REGEX.user[field], "").replace(/\s{2,}/g, " ").trim();
  }
}

export default StringUtils;
